import { useTranslation } from "react-i18next";
import SEO from "./common/SEO";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faCookieBite,
  faCheckCircle,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";

const PrivacyPolicy = ({ renderBody }) => {
  const { t, i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");
  const title = isEnglish ? "Privacy & Cookie Policy" : "Informativa Privacy & Cookie";
  const desc = isEnglish
    ? "Privacy and Cookie Policy for the official website of Nuova Orchestra da Camera Ferruccio Busoni (orchestrabusoni.it)."
    : "Informativa estesa sulla privacy e sull'uso dei cookie per il sito ufficiale dell'Associazione Nuova Orchestra da Camera Ferruccio Busoni.";

  return (
    <>
      <SEO title={title} description={desc} />
      <section className="section subpage-section">
        <div className="container subpage-container">
          {/* Header */}
          <div className="text-center mb-5">
            <h2 className="subpage-title">{title}</h2>
            <p className="text-muted max-w-700 mx-auto mt-2">
              {isEnglish
                ? "Information on the processing of personal data and cookie policy in accordance with EU Regulation 2016/679 (GDPR)."
                : "Informativa sul trattamento dei dati personali e sull'utilizzo dei cookie ai sensi del Regolamento UE 2016/679 (GDPR) e D.Lgs. 196/2003."}
            </p>
          </div>

          {/* Privacy Guarantee Banner */}
          <div className="alert alert-success border-0 rounded-4 p-4 mb-5 shadow-sm d-flex align-items-center">
            <FontAwesomeIcon icon={faCheckCircle} className="text-success fs-2 me-3" />
            <div>
              <h5 className="alert-heading mb-1 fw-bold text-success">
                {t("privacy.tit5")}
              </h5>
              <p className="mb-0 text-dark small">
                {isEnglish
                  ? "This site uses exclusively technical cookies strictly necessary for browsing and does NOT track users for profiling purposes."
                  : "Questo sito utilizza esclusivamente cookie tecnici necessari per il corretto funzionamento e non raccoglie dati per finalità pubblicitarie o di profilazione."}
              </p>
            </div>
          </div>

          {/* Policy Sections */}
          <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5 bg-white mb-4">
            <h4 className="section-subheading mb-3 pb-2 border-bottom d-flex align-items-center text-capitalize">
              <FontAwesomeIcon icon={faLock} className="text-warning me-2 fs-5" />
              Disclaimer & Proprietà Intellettuale
            </h4>
            <div className="subpage-text-content mb-5">
              {t("privacy.par1")}
            </div>

            <h4 className="section-subheading mb-3 pb-2 border-bottom d-flex align-items-center text-capitalize">
              <FontAwesomeIcon icon={faShieldAlt} className="text-warning me-2 fs-5" />
              {t("privacy.tit2")}
            </h4>
            <div className="subpage-text-content mb-5">
              {t("privacy.par2")}
            </div>

            <h4 className="section-subheading mb-3 pb-2 border-bottom d-flex align-items-center text-capitalize">
              <FontAwesomeIcon icon={faLock} className="text-warning me-2 fs-5" />
              {t("privacy.tit3")}
            </h4>
            <div className="subpage-text-content mb-5">
              {t("privacy.par3")}
            </div>

            <h4 className="section-subheading mb-3 pb-2 border-bottom d-flex align-items-center text-capitalize">
              <FontAwesomeIcon icon={faCookieBite} className="text-warning me-2 fs-5" />
              {t("privacy.tit4")}
            </h4>
            <div className="subpage-text-content mb-5">
              {renderBody(t("privacy.par4"))}
            </div>

            <h4 className="section-subheading mb-3 pb-2 border-bottom d-flex align-items-center text-capitalize">
              <FontAwesomeIcon icon={faCookieBite} className="text-warning me-2 fs-5" />
              {t("privacy.tit6")}
            </h4>
            <div className="subpage-text-content">
              {renderBody(t("privacy.par6"))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
